import { DocumentListHeader } from "../DocumentListHeader"
import { DocumentListLayout } from "../documentListLayout"
import { DocumentListSidePanel } from "../DocumentListSidePanel"
import { DocumentListProvider } from "../useDocumentList"

export function ReleasesList() {
  return (
    <DocumentListProvider>
      <DocumentListLayout
        header={<DocumentListHeader tab="upcoming" />}
        sidePanel={<DocumentListSidePanel />}
        // TODO: Implement ReleasesList body
        // https://linear.app/prismic/issue/PBD-1405/release-component
        body={<div>ReleasesList</div>}
      />
    </DocumentListProvider>
  )
}
